import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useParams } from 'react-router';

import { Box, Paper, Tabs, Tab, Grid, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import moment from 'moment';
import 'moment/locale/es-mx';

import { TabProps, TabPanel } from '../../../helpers/TabPanel';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { Layout } from '../../../components/Layout';
import { BoxProcesoCancelado } from '../../../components/BoxProcesoCancelado';
import { BoxProcesoTerminado } from '../../../components/BoxProcesoTerminado';
import { BoxInformacionAmparo } from '../../../components/BoxInformacionAmparo';
import { BoxHeaderInformacion } from '../../../components/BoxHeaderInformacion';
import { BoxProcesoNoEncontrado } from '../../../components/BoxProcesoNoEncontrado';
import { BoxInformacionPromocion } from '../../../components/BoxInformacionPromocion';
import { BoxInformacionIrregular } from '../../../components/BoxInformacionIrregular';
import { BoxInformacionExpediente } from '../../../components/BoxInformacionExpediente';
import { CircularProgressIndicator } from '../../../components/CircularProgressIndicator';
import { BoxInformacionExhortoRecibido } from '../../../components/BoxInformacionExhortoRecibido';

import { Notificacion } from '../ui/Notificacion';

import { ActualizarEstatus, DetalleAcuerdo, GuardarAcuerdo } from '../../../connections/tribunal/AcuerdoConnection';

import { defaultTabValidation, TabValidationProps } from '../../../interfaces/ui/TabValidation';
import { defaultUsuarioPoderEnLinea, UsuarioPoderEnLineaProps } from '../../../interfaces/admin/UsuarioInterface';
import { AcuerdoProps, defaultAcuerdo, GuardarAcuerdoParams } from '../../../interfaces/tribunal/AcuerdoInterface';
import { defaultMedioImpugnacionParams } from '../../../interfaces/tribunal/MedioImpugnacionInterface';
import { NotificacionesProps } from '../../../interfaces/notificaciones/NotificacionesInterface';

const edit = false;

export const VisualizarAcuerdoPage = () => {

    const dispatch = useDispatch();

    const { Id } = useParams();

    const [value, setValue] = useState( 0 );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [openConfirmacion, setOpenConfirmacion] = useState( false );

    const [tabValidation, setTabValidation] = useState<TabValidationProps>( defaultTabValidation );

    const [tipoAcuerdo, setTipoAcuerdo] = useState( 0 );

    const [subTipoAcuerdo, setSubTipoAcuerdo] = useState( 0 );

    const [mecanografo, setMecanografo] = useState( 0 );

    const [autorizarExpedienteVirtual, setAutorizarExpedienteVirtual] = useState( false );
    const [archivoProvisional, setArchivoProvisional] = useState( false );

    const [usuarioPL, setUsuarioPL] = useState<UsuarioPoderEnLineaProps>( defaultUsuarioPoderEnLinea );

    const [tipoReservadoActor, setTipoReservadoActor] = useState( false );
    const [tipoReservadoDemandado, setTipoReservadoDemandado] = useState( false );

    const [contenido, setContenido] = useState( '' );
    const [plantilla, setPlantilla] = useState( 0 );

    //-------------------------------- Información y catálogos del exhorto recibido ----------------------------------------------

    const [autoridadExhortoRecibido, setAutoridadExhortoRecibido] = useState( 0 );
    const [claseExhorto, setClaseExhorto] = useState( 0 );
    const [objetoExhorto, setObjetoExhorto] = useState( 0 );

    //----------------------------  Información de recursos, incidentes y ejecución   --------------------------------------------

    const [promocionIrregular, setPromocionIrregular] = useState( false );
    const [interponeIncidente, setInterponeIncidente] = useState( false );
    const [interponeRecurso, setInterponeRecurso] = useState( false );
    const [resuelveRecurso, setResuelveRecurso] = useState( false );

    const [enviarPromocion, setEnviarPromocion] = useState( false );

    const [medioImpugnacionSelected, setMedioImpugnacionSelected] = useState( 0 );
    const [medioImpugnacion, setMedioImpugnacion] = useState( defaultMedioImpugnacionParams );
    const [fechaRemisionAlzada, setFechaRemisionAlzada] = useState( moment( new Date() ).format( 'YYYY-MM-DD' ) );

    const [sentidoFallo, setSentidoFallo] = useState( 0 );
    const [fechaDevolucionAlzada, setFechaDevolucionAlzada] = useState( moment( new Date() ).format( 'YYYY-MM-DD' ) );

    //--------------------------------------------------------------------------------------------------------------------------------------------

    const [etapa, setEtapa] = useState( 0 );
    const [subEtapa, setSubEtapa] = useState( 0 );

    //--------------------------------------------------------------------------------------------------------------------------------------------

    const [fechaResolucion, setFechaResolucion] = useState( moment( new Date() ).format( 'YYYY-MM-DD' ) );

    //----------------------------------------------------------------------------------------------

    const [tipoSentencia, setTipoSentencia] = useState( 0 );
    const [citaSentencia, setCitaSentencia] = useState( false );
    const [citacionSentencia, setCitacionSentencia] = useState( 0 );

    //----------------------------------------------------------------------------------------------

    const [solicitarFechaAudiencia, setSolicitarFechaAudiencia] = useState( false );

    //----------------------------------------------------------------------------------------------

    const [acuerdo, setAcuerdo] = useState<AcuerdoProps>( defaultAcuerdo );
    const [notificaciones, setNotificaciones] = useState<NotificacionesProps[]>( [] );

    const handleChange = (_: React.SyntheticEvent, newValue: number) => setValue( newValue )

    const Guardar = async () => {

        const tipoReservado = ( tipoReservadoActor && tipoReservadoDemandado ) ? 3 : tipoReservadoActor ? 1 : tipoReservadoDemandado ? 2 : 0;

        const params: GuardarAcuerdoParams = {
            id: Id ?? '',
            idTipoAcuerdo: tipoAcuerdo,
            idSubTipoAcuerdo: subTipoAcuerdo,
            idTipoReservado: tipoReservado,
            idUsuarioElaboro: mecanografo,
            idPlantilla: plantilla,
            usuarioPoderEnLinea: usuarioPL,
            autorizarExpedienteVirtual,
            archivoProvisional,
            enviarPromocion,
            observaciones: '',
            contenido,
            idAutoridadExhortoRecibido: autoridadExhortoRecibido,
            idObjetoExhorto: objetoExhorto,
            idClaseExhorto: claseExhorto,
            promocionIrregular,
            interponeIncidente,
            interponeRecurso,
            resuelveRecurso,
            medioImpugnacion,
            idMedioImpugnacion: medioImpugnacionSelected,
            fechaRemisionAlzada: tipoAcuerdo === 21 ? moment( fechaRemisionAlzada ).format('YYYY-MM-DD') : '',
            idSentidoFallo: sentidoFallo,
            fechaDevolucionAlzada: resuelveRecurso ? fechaDevolucionAlzada : '',
            idEtapa: etapa,
            idSubEtapa: subEtapa,
            fechaResolucionAmparo: fechaResolucion,
            idTipoSentencia: tipoSentencia,
            idCitacionSentencia: citacionSentencia,
            citaSentencia,
            solicitarFechaAudiencia,
        };

        return await GuardarAcuerdo( params );
    }

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if ( !successGuardar ) {

            setTimeout(() => {

                dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }));

                setLoadingFinalizar( false );

            }, 700);

        }

        await ActualizarEstatus({ id: Id ?? '', idEstatus: 3 }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setAcuerdo({ ...acuerdo, idEstatus: 3 });

                    setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );

                    setProcesoTerminado( true );
                    setLoadingFinalizar( false );
                    setOpenConfirmacion( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener() {

            await DetalleAcuerdo( Id ?? '' ).then( resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setAcuerdo( resp );

                        setTabValidation({
                            idAmparo: resp.idAmparo,
                            idDemandaInicial: resp.idDemandaInicial,
                            idExhortoRecibido: resp.idExhortoRecibido,
                            idExpediente: resp.idExpediente,
                            idIrregular: resp.idIrregular,
                            idPromocion: resp.idPromocion,
                        });

                        setTipoAcuerdo( resp.idTipoAcuerdo );
                        setSubTipoAcuerdo( resp.idSubTipoAcuerdo );
                        setMecanografo( resp.idUsuarioElaboro );
                        setContenido( resp.contenido );
                        setNotificaciones( resp.notificaciones );
                        setPlantilla( resp.idPlantilla );

                        setAutorizarExpedienteVirtual( resp.autorizarExpedienteVirtual );
                        setUsuarioPL( resp.usuarioPoderEnLinea );

                        setArchivoProvisional( resp.archivoProvisional );
                        setEnviarPromocion( resp.enviarPromocion );

                        setTipoReservadoActor( [1, 3].includes( resp.idTipoReservado ) );
                        setTipoReservadoDemandado( [2, 3].includes( resp.idTipoReservado ) );

                        setPromocionIrregular( resp.promocionIrregular );

                        setInterponeIncidente( resp.interponeIncidente );
                        setInterponeRecurso( resp.interponeRecurso );
                        setResuelveRecurso( resp.resuelveRecurso );

                        setMedioImpugnacion( resp.medioImpugnacion );

                        setMedioImpugnacionSelected( resp.idMedioImpugnacion );
                        setSentidoFallo( resp.idSentidoFallo );
                        setFechaRemisionAlzada( moment( resp.fechaRemisionAlzada ?? new Date() ).format('YYYY-MM-DD') );
                        setFechaDevolucionAlzada( moment( resp.fechaDevolucionAlzada ?? new Date() ).format('YYYY-MM-DD') );

                        setEtapa( resp.idEtapa );
                        setSubEtapa( resp.idSubEtapa );

                        setFechaResolucion( moment( resp.fechaResolucionAmparo ?? new Date() ).format('YYYY-MM-DD') );

                        setTipoSentencia( resp.idTipoSentencia );
                        setCitaSentencia( resp.citaSentencia );
                        setCitacionSentencia( resp.idCitacionSentencia );

                        setSolicitarFechaAudiencia( resp.solicitarFechaAudiencia );

                        if( resp.idPromocion === 0 && resp.idExhortoRecibido !== 0 ){

                            setAutoridadExhortoRecibido( resp.exhortoRecibido.idAutoridadExhortoRecibido );
                            setObjetoExhorto( resp.exhortoRecibido.idObjetoExhorto );
                            setClaseExhorto( resp.exhortoRecibido.idClaseExhorto );

                        }

                        if( resp.idEstatus === 3 ){
                            setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
                            setProcesoTerminado( true );
                            setLoading(false);
                        }
                        else if( resp.idEstatus === 4 ){
                            setProcesoCancelado( true );
                            setLoading(false);
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion( `La siguiente actividad se asignó a ${ resp.usuarioAsignado }` );
                            setProcesoTerminado( true );
                            setLoading(false);
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 27 ) {
                            setMensajeAsignacion( 'La siguiente actividad se encuentra en tu bandeja' );
                            setProcesoTerminado( true );
                            setLoading(false);
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 27 ) {
                            setLoading(false);
                        }
                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });
        }

        if( Id ){
            Obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Acuerdo' }, { text: 'Visualizar acuerdo' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                ?
                    procesoNoEncontrado
                    ?
                        <BoxProcesoNoEncontrado />
                    :
                        procesoCancelado
                        ?
                            <BoxProcesoCancelado />
                        :
                            <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ acuerdo.idEstatus === 3 } />
                :
                    loading
                    ?
                        <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                            <CircularProgressIndicator />
                        </Box>
                    :
                        <>

                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                <Tabs value={ value } onChange={ handleChange }>

                                    <Tab label="Acuerdo" {...TabProps(0)} />
                                    <Tab label="Notificación" {...TabProps(1)} />

                                    <Tab
                                        label="Información del promoción"
                                        sx={{ display: tabValidation.idPromocion !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(2)}
                                    />

                                    <Tab
                                        label="Información del amparo"
                                        sx={{ display: tabValidation.idAmparo !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(3)}
                                    />

                                <Tab
                                        label={ tabValidation.idDemandaInicial ? " Información de la demanda" : "Información del expediente" }
                                        sx={{ display: ( tabValidation.idExpediente !== 0 || tabValidation.idDemandaInicial !== 0 ) ? 'flex' : 'none' }}
                                        {...TabProps(4)}
                                    />

                                    <Tab
                                        label="Información del exhorto"
                                        sx={{ display: tabValidation.idExhortoRecibido !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(5)}
                                    />

                                    <Tab
                                        label="Información del irregular"
                                        sx={{ display: tabValidation.idIrregular !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(6)}
                                    />

                                </Tabs>

                            </Box>

                            <TabPanel value={ value } index={ 0 }>

                                <Box p={ 4 } component={ Paper }>

                                    <BoxHeaderInformacion numeroSeguimiento={`GAC-${ acuerdo.idAcuerdo }`} fecha={ acuerdo.fecha ?? new Date() } juez={ acuerdo.juez } />

                                    <Grid container spacing={ 3 } mt={ 2 }>

                                        <Grid size={{ md: 12, xs: 12 }}>

                                            {
                                                acuerdo.documento
                                                &&
                                                    <iframe
                                                        title='iframe-documento'
                                                        style={{ width: '100%', height: 800, borderRadius: 8 }}
                                                        src={ acuerdo.documento }
                                                    />
                                            }

                                        </Grid>

                                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                            <Grid container spacing={ 3 }>

                                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left'}}> </Grid>

                                                <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'center' }}>
                                                    <Button
                                                        fullWidth
                                                        color='primary'
                                                        variant="contained"
                                                        onClick={ () => setOpenConfirmacion( true ) }
                                                    >
                                                        Finalizar
                                                    </Button>
                                                </Grid>

                                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right'}}> </Grid>

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Box>

                            </TabPanel>

                            <TabPanel value={ value } index={ 1 }>

                                <Notificacion
                                    acuerdo={ acuerdo }
                                    notificaciones={ notificaciones }
                                    setNotificaciones={ setNotificaciones }
                                    edit={ edit }
                                />

                            </TabPanel>

                            <TabPanel value={ value } index={ 2 }>

                                <BoxInformacionPromocion
                                     promocion={ acuerdo.promocion }
                                />

                            </TabPanel>

                            <TabPanel value={ value } index={ 3 }>

                                <BoxInformacionAmparo amparo={ acuerdo.amparo } />

                            </TabPanel>

                            <TabPanel value={ value } index={ 4 }>

                                <BoxInformacionExpediente
                                    expediente={ acuerdo.expediente }
                                    demandaInicial={ acuerdo.demandaInicial }
                                />

                            </TabPanel>

                            <TabPanel value={ value } index={ 5 }>

                                <BoxInformacionExhortoRecibido
                                    exhortoRecibido={ acuerdo.exhortoRecibido }
                                />

                            </TabPanel>

                            <TabPanel value={ value } index={ 6 }>

                                <BoxInformacionIrregular irregular={ acuerdo.irregular } />

                            </TabPanel>

                        </>
            }

            <Dialog
                maxWidth='sm'
                fullWidth
                open={ openConfirmacion }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        ¿Desea finalizar la visualización del acuerdo?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={ loadingFinalizar } onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                    <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>

                </DialogActions>
            </Dialog>

        </Layout>
    )
}
